import React from 'react';

import { Theme, createStyles, withStyles, Button, MenuItem } from '@material-ui/core';
import { FormControl, Select, InputLabel } from '@material-ui/core';

import style from './fwdAccounts.module.css';
import ForwarderModel from '../../../models/ForwarderAwb';


const useStyles = (theme: Theme) =>

  createStyles({
    formControl: {
      width: '386px',
      marginRight: '40px'
    },
    selectLabel: {
      transform: 'translate(14px, 29px) scale(1) ',
      color: 'var(--primaryblue)',
    },
    shrinkLabel: {
      transform: 'translate(14px, 10px) scale(0.75) !important',
    },
    select: {
      '& [class^="MuiSelect-select-"]': {
        padding: '11px 35px 11px 14px',
        color: 'var(--primaryblue)'
      }
    },
    styleInputProps: {
      color: 'var(--primaryblue)', 
      fontSize: '0.8125rem'
    },
    helperText: {
      color: 'red',
      paddingLeft: '15px'
    }
  });

interface AddNewForwarderAccountProps {
  classes: any;
  items: Array<ForwarderModel>;
  value: number | undefined ;
  onChange: (event: any) => void;
  onClick: () => void;
}

const addNewForwarderAccount = (props: AddNewForwarderAccountProps) => {

  const { classes } = props;
  const FwdOptions: Array<JSX.Element> = props.items.map((item: ForwarderModel, index: number ) => {
    return (
      <MenuItem key={ index } value={ item.id }>{ item.name }</MenuItem> 
    );
  });

  const shrink: boolean = props.value ? true : false;
  return (
      <div className={ style.dropDownFwdWrapper }>
        <FormControl className={ classes.formControl }>
          <InputLabel 
            htmlFor='company' 
            shrink={ shrink }
            className={ classes.selectLabel } 
            classes={{
              shrink: classes.shrinkLabel
            }}
          >
            Select a forwarder
          </InputLabel>
          <Select 
            value={ props.value }
            onChange={ props.onChange }
            inputProps={{
              name:'company',
              id: 'company',
              className: classes.styleInputProps
            }}
            className={ classes.select }
          >
            <MenuItem value={0} />
            { FwdOptions }
          </Select>
        </FormControl>
       
          <Button 
            color="primary"
            variant="contained" 
            onClick={ props.onClick }
            disabled={ !props.value }
          > 
            Create Account
          </Button>
        
      </div>
  );
};

export default withStyles(useStyles)(addNewForwarderAccount);